
export const nip = (state = [], action) => { 
    switch (action.type) {
        case 'NIP_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const companyName = (state = [], action) => { 
    switch (action.type) {
        case 'COMPANY_NAME_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const companyAddress = (state = [], action) => { 
    switch (action.type) {
        case 'COMPANY_ADDRESS_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const postalCustomer = (state = [], action) => { 
    switch (action.type) {
        case 'POSTAL_CUSTOMER_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const city = (state = [], action) => { 
    switch (action.type) {
        case 'CITY_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const companyStart = (state = [], action) => { 
    switch (action.type) {
        case 'COMPANY_START_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const registryType = (state = [], action) => { 
    switch (action.type) {
        case 'REGISTRY_TYPE_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const idNumber = (state = [], action) => { 
    switch (action.type) {
        case 'ID_NUMBER_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const phone = (state = [], action) => { 
    switch (action.type) {
        case 'PHONE_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const email = (state = [], action) => { 
    switch (action.type) {
        case 'EMAIL_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const lawForm = (state = [], action) => { 
    switch (action.type) {
        case 'LAW_FORM_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const profession = (state = [], action) => { 
    switch (action.type) {
        case 'PROFESSION_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const employeesNumber = (state = [], action) => { 
    switch (action.type) {
        case 'EMPLOYEES_NUMBER_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const website = (state = [], action) => { 
    switch (action.type) {
        case 'WEBSITE_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const additionalAddress = (state = false, action) => { 
    switch (action.type) {
        case 'ADDITIONAL_ADDRESS_CHANGE':
            return action.value;      
        default:
            return state
    }
}
export const additionalCompanyAddress = (state = "", action) => { 
    switch (action.type) {
        case 'ADDITIONAL_COMPANY_ADDRESS_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const additionalPostalCustomer = (state = [], action) => { 
    switch (action.type) {
        case 'ADDITIONAL_POSTAL_CUSTOMER_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const additionalCity = (state = "", action) => { 
    switch (action.type) {
        case 'ADDITIONAL_CITY_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const emailFV = (state = [], action) => { 
    switch (action.type) {
        case 'EMAIL_FV_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const dataFromGUS = (state = [], action) => { 
    switch (action.type) {
        case 'GUS_DATA_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const bank = (state = [], action) => { 
    switch (action.type) {
        case 'BANK_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const bankURI = (state = [], action) => { 
    switch (action.type) {
        case 'BANK_URI_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const bankAccountsNumbers = (state = [], action) => { 
    switch (action.type) {
        case 'BANK_ACCOUNTS_NUMBERS_CHANGE':
            return action.value;      
        default:
            return state
    }
}


export const bankAccount = (state = [], action) => { 
    switch (action.type) {
        case 'BANK_ACCOUNT_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const otherBankAccountCheckbox = (state = false, action) => { 
    switch (action.type) {
        case 'OTHER_BANK_ACCOUNT_CHECKBOX_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const otherBankAccount = (state = [], action) => { 
    switch (action.type) {
        case 'OTHER_BANK_ACCOUNT_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const consentAutomaticBankAccountCheckbox = (state = false, action) => { 
    switch (action.type) {
        case 'CONSENT_AUTOMATIC_BANK_ACCOUNT_CHECKBOX_CHANGE':
            return action.value;      
        default:
            return state
    }
}

//new

export const legalRepresentative = (state = [], action) => { 
    switch (action.type) {
        case 'LEGAL_REPRESENTATIVE_CHANGE':
            return action.value;      
        default:
            return state
    }
}